import type { ReactNode } from 'react';
import type { QuotePerson } from './types';
import { Card } from './ui/primitives';

/**
 * A list of people or entities attached to the quote — assigned admins, vetters.
 *
 * Empty is a real state and says what it means: a quote with no vetters ships
 * without external review, which is a decision rather than missing data.
 */
export function QuotePeople({
	people,
	emptyLabel,
	emptyIcon,
}: {
	people: QuotePerson[];
	emptyLabel: string;
	emptyIcon?: ReactNode;
}) {
	return (
		<Card padded>
			{people.length === 0 ? (
				<div className="flex items-center gap-2 py-px">
					{emptyIcon}
					<span className="text-sm text-text-4">{emptyLabel}</span>
				</div>
			) : (
				<div className="flex flex-col gap-2">
					{people.map((person) => (
						<div key={person.id} className="flex items-center gap-2">
							{person.avatar}
							<span className="min-w-0 flex-1 truncate text-base text-text-1">
								{person.name}
							</span>
							{person.meta && (
								<span className="shrink-0 text-xs text-text-4">{person.meta}</span>
							)}
							{person.details}
						</div>
					))}
				</div>
			)}
		</Card>
	);
}
